import styled from '@emotion/styled'

export const VenderInfoContainer = styled.div((props) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  height: 'auto',

  '.address': {
    display: 'flex',
  },

  '.tel': {
    display: 'flex',
  },
}))

export const ContactPersonContainer = styled.div((props) => ({
  display: 'flex'
}))